import React from 'react';
import { TableModifier, TableCell, TableRow } from '../../../../../organisms/Table';

type EditorHelpShortcutRowProps = {
  action: string;
  shortcut: string[];
};

export function EditorHelpShortcutRow({ action, shortcut }: EditorHelpShortcutRowProps) {
  return (
    <TableRow key={action}>
      <TableCell modifier={TableModifier.LOWPADDING}>{action}</TableCell>
      <TableCell modifier={TableModifier.LOWPADDING}>
        {shortcut
          .map(keyboard => (
            <kbd key={keyboard} className="editor__help-button">
              {keyboard}
            </kbd>
          ))
          .reduce((acc: any, element) => {
            if (acc.length > 0) {
              acc.push('+');
            }

            acc.push(element);

            return acc;
          }, [])}
      </TableCell>
    </TableRow>
  );
}
